import { CalculatorOutlined, CalendarOutlined, CodeSandboxOutlined, CreditCardOutlined, DollarOutlined, HomeOutlined, LogoutOutlined, SearchOutlined, SettingOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Drawer, Menu } from 'antd';
import { useMedia } from 'hooks';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ALL_WORKS_ROUTE, LOGIN, MOVERS_SALARY_ROUTE, MY_WORKS_ROUTE, PRICES_ROUTE, SALES_SALARY_ROUTE, SCHEDULE_ROUTE, SEARCH_ROUTE, USERS_ROUTE } from 'routes/consts';
import { userStore } from 'stores';

const ICON_STYLES = {
	fontSize: 20
};

export const AppMenu = observer(() => {
	const { isMobile } = useMedia();
	const [drawer, openDrawer] = useState(false);
	const navigate = useNavigate();

	const handleLogout = useCallback(() => {
		userStore.logout(); 
		navigate('/'); 
	}, [navigate]);

	const logoutItem = useMemo(() => ({
		label: <span onClick={() => handleLogout()}><LogoutOutlined style={ICON_STYLES} /> Log out</span>,
		key: 'logout',
		onClick: handleLogout
	}), [handleLogout]);

	const workerItems = useMemo(() => [
		{
			label: <NavLink to={MOVERS_SALARY_ROUTE}><CreditCardOutlined style={ICON_STYLES} /> Salaries</NavLink>,
			key: 'salaries'
		},
		{
			label: <NavLink to={MY_WORKS_ROUTE}><CodeSandboxOutlined style={ICON_STYLES} /> My works</NavLink>,
			key: 'my-works'
		},
		{
			label: <NavLink to={SCHEDULE_ROUTE}><CalendarOutlined style={ICON_STYLES} /> Schedule</NavLink>,
			key: 'schedule'
		},
		logoutItem
	], [logoutItem]);

	const adminItems = useMemo(() => [
		{
			label: <NavLink to={LOGIN}><HomeOutlined style={ICON_STYLES} /> Works</NavLink>,
			key: 'home'
		}, {
			label: <NavLink to={ALL_WORKS_ROUTE}><CalculatorOutlined style={ICON_STYLES} /> Completed</NavLink>,
			key: 'jobs'
		}, {
			label: <NavLink to={SCHEDULE_ROUTE}><CalendarOutlined style={ICON_STYLES} /> Schedule</NavLink>,
			key: 'schedule'
		},
		{
			label: <NavLink to={SEARCH_ROUTE}><SearchOutlined style={ICON_STYLES} /> Search</NavLink>,
			key: 'search'
		},
		{
			label: <span onClick={() => openDrawer(true)}><SettingOutlined style={ICON_STYLES} /> Settings</span>,
			key: 'settings'
		}
	], []);

	const settingsItems = useMemo(() => {
		const arr = [
			{
				label: <NavLink to={USERS_ROUTE}><UsergroupAddOutlined style={ICON_STYLES} /> Users</NavLink>,
				key: 'users'
			},
			{
				label: <NavLink to={MOVERS_SALARY_ROUTE}><CreditCardOutlined style={ICON_STYLES} /> Movers salary</NavLink>,
				key: 'movers-salary'
			},
			{
				label: <NavLink to={MY_WORKS_ROUTE}><CodeSandboxOutlined style={ICON_STYLES} /> Assigned works</NavLink>,
				key: 'my-works'
			},
			logoutItem
		];
		if(userStore.isAdmin) {
			arr.unshift({
				label: <NavLink to={PRICES_ROUTE}><DollarOutlined style={ICON_STYLES} /> Prices</NavLink>,
				key: 'prices'
			},{
				label: <NavLink to={SALES_SALARY_ROUTE}><CreditCardOutlined style={ICON_STYLES} /> Sales salary</NavLink>,
				key: 'sales-salary'
			});	
		}

		return arr;
	}, [logoutItem]);

	const items = useMemo(() => {
		return (userStore.isStaff) ? adminItems : workerItems;
	}, [adminItems, workerItems]);

	return (
		<>
			<Drawer
				title="Settings"
				open={drawer}
				onClose={() => openDrawer(false)}
			>
				<Menu
					mode="inline"
					items={settingsItems}
					onClick={() => openDrawer(false)}
				/>
			</Drawer>
			{isMobile ? (
				<div className="mobile-menu">
					{items.map(el => (
						<div className="mobile-menu-item" key={el?.key}>
							{el?.label}
						</div>
					))}
				</div>
			) : (
				<Menu
					theme="dark"
					mode="horizontal"
					items={items}
					style={{ minWidth: 0, flex: 'auto' }}
				/>
			)}	
		</>
	);
});